import {gql} from '@apollo/client';

export const QUERY_SHOWCASE = gql`
    query onlyCashOffers ($token: String!) {
        onlyCashOffers(token: $token) {
            id
            attributes {
                headline
                percent
                term
                age
                logo {
                    data {
                        id
                        attributes {
                            url
                        }
                    }
                }
                URL
            }
        }
    }
`